module.exports = __webpack_public_path__ + "static/media/2_en.ebb7e533.png";